import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'retraced_risk_score'

export const dataPointDefinition = {
  retracedId: 'retraced_risk_score',
  name: 'Retraced Risk Score',
  description:
    'The Retraced Standard Risk Score is automatically calculated based on the data points that are available to you.',
  meta: {
    tooltip:
      'This field is automatically filled with risk score calculated based on the retraced standard assessment. Users cannot change this value.',
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
        minimum: 1,
        maximum: 5,
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 55,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
